import {gtmEcommerceOfferTypeMap} from "@pg-rp/common-types";

import {ApplicationSourceSection, getApplicationSourceSectionDisplay} from "../../../../application/utils/ApplicationSource";
import {notifyBugsnag} from "../../../../errors/bugsnag/notify_bugsnag";
import {ILeadModalLeadType} from "../../../../lead/types/ILeadModalLeadType";
import {hitGoogleTagManager} from "../../../../tracking/google_tag_manager/hit_google_tag_manager";
import {IGTMEcommerce} from "../../../../tracking/types/ecommerce/IGTMEcommerce";
import {IGTMEcommerceItem} from "../../../../tracking/types/ecommerce/IGTMEcommerceItem";
import {getCurrencyISOCode} from "../../../../utils/get_currency";
import {getViewTypeName, ViewType} from "../../../../view_type/ViewType";
import {OfferType} from "../../../types/OfferType";
import {getGtmEcommerceOfferEventCategoryByLeadType} from "../common/get_gtm_ecommerce_offer_event_category_by_lead_type";
import {getGtmEcommerceOfferItemBaseProps} from "../common/get_gtm_ecommerce_offer_item_base_props";
import {getGTMEcommerceOfferRegion} from "../common/get_gtm_ecommerce_offer_region";
import {getGTMEcommercePropertyProps} from "../common/get_gtm_ecommerce_property_props";
import {GTMEcommerceAvailability} from "../types/gtm_ecommerce_availability";
import {GTMEcommerceItemStatus} from "../types/gtm_ecommerce_item_status";
import {IGTMEcommerceAddProductData} from "../types/IGTMEcommerceAddProductData";

export const hitGTMPropertyAddToCart = (
    data: IGTMEcommerceAddProductData,
    viewType: ViewType | null,
    leadType: ILeadModalLeadType,
    sourceSection: ApplicationSourceSection
) => {
    const vendorData = (data.vendor && data.vendor.detail) || undefined;
    const offerData = (data.offer && data.offer.detail) || undefined;
    const regionData = (offerData && offerData.region) || undefined;
    const propertyData = (data.property && data.property.detail) || undefined;

    if (!vendorData || !offerData || !regionData || !propertyData) {
        notifyBugsnag(
            JSON.stringify({
                vendor: Boolean(vendorData),
                offer: Boolean(offerData),
                region: Boolean(regionData),
                property: Boolean(propertyData)
            }),
            "hitGTMPropertyAddToCart missing data"
        );
        return;
    }

    const item = {
        ...getGtmEcommerceOfferItemBaseProps({
            ...offerData,
            vendor: {
                name: vendorData.name
            }
        }),
        item_category: "property",
        price: 1,
        quantity: 1,
        availability: GTMEcommerceAvailability.IN_STOCK,
        item_status: GTMEcommerceItemStatus.Active,
        item_type: gtmEcommerceOfferTypeMap[offerData.type as OfferType],
        item_source: getApplicationSourceSectionDisplay(sourceSection) || "na",
        item_list_name: viewType ? getViewTypeName(viewType) : "na",
        item_list_id: leadType?.toString() || "na",
        item_comissioning_date: offerData.construction_date_range.upper || "na",
        ...getGTMEcommerceOfferRegion(regionData),
        ...getGTMEcommercePropertyProps({
            property: propertyData,
            short: false
        })
    } as IGTMEcommerceItem;

    const ecommerce: IGTMEcommerce = {
        currency: getCurrencyISOCode(offerData.currency),
        value: 1,
        items: [item]
    };

    hitGoogleTagManager({
        event: "add_to_cart",
        event_category: getGtmEcommerceOfferEventCategoryByLeadType(leadType),
        ecommerce
    });
};
import {gtmEcommerceOfferTypeMap} from "@pg-rp/common-types";

import {ApplicationSourceSection, getApplicationSourceSectionDisplay} from "../../../../application/utils/ApplicationSource";
import {notifyBugsnag} from "../../../../errors/bugsnag/notify_bugsnag";
import {ILeadModalLeadType} from "../../../../lead/types/ILeadModalLeadType";
import {hitGoogleTagManager} from "../../../../tracking/google_tag_manager/hit_google_tag_manager";
import {IGTMEcommerce} from "../../../../tracking/types/ecommerce/IGTMEcommerce";
import {IGTMEcommerceItem} from "../../../../tracking/types/ecommerce/IGTMEcommerceItem";
import {getCurrencyISOCode} from "../../../../utils/get_currency";
import {getViewTypeName, ViewType} from "../../../../view_type/ViewType";
import {OfferType} from "../../../types/OfferType";
import {getGtmEcommerceOfferEventCategoryByLeadType} from "../common/get_gtm_ecommerce_offer_event_category_by_lead_type";
import {getGtmEcommerceOfferItemBaseProps} from "../common/get_gtm_ecommerce_offer_item_base_props";
import {getGTMEcommerceOfferRegion} from "../common/get_gtm_ecommerce_offer_region";
import {getGTMEcommercePropertyProps} from "../common/get_gtm_ecommerce_property_props";
import {GTMEcommerceAvailability} from "../types/gtm_ecommerce_availability";
import {GTMEcommerceItemStatus} from "../types/gtm_ecommerce_item_status";
import {IGTMEcommerceAddProductData} from "../types/IGTMEcommerceAddProductData";

export const hitGTMPropertyAddToCart = (
    data: IGTMEcommerceAddProductData,
    viewType: ViewType | null,
    leadType: ILeadModalLeadType,
    sourceSection: ApplicationSourceSection
) => {
    const vendorData = (data.vendor && data.vendor.detail) || undefined;
    const offerData = (data.offer && data.offer.detail) || undefined;
    const regionData = (offerData && offerData.region) || undefined;
    const propertyData = (data.property && data.property.detail) || undefined;

    if (!vendorData || !offerData || !regionData || !propertyData) {
        notifyBugsnag(
            JSON.stringify({
                vendor: Boolean(vendorData),
                offer: Boolean(offerData),
                region: Boolean(regionData),
                property: Boolean(propertyData)
            }),
            "hitGTMPropertyAddToCart missing data"
        );
        return;
    }

    const item = {
        ...getGtmEcommerceOfferItemBaseProps({
            ...offerData,
            vendor: {
                name: vendorData.name
            }
        }),
        item_category: "property",
        price: 1,
        quantity: 1,
        availability: GTMEcommerceAvailability.IN_STOCK,
        item_status: GTMEcommerceItemStatus.Active,
        item_type: gtmEcommerceOfferTypeMap[offerData.type as OfferType],
        item_source: getApplicationSourceSectionDisplay(sourceSection) || "na",
        item_list_name: viewType ? getViewTypeName(viewType) : "na",
        item_list_id: leadType?.toString() || "na",
        item_comissioning_date: offerData.construction_date_range.upper || "na",
        ...getGTMEcommerceOfferRegion(regionData),
        ...getGTMEcommercePropertyProps({
            property: propertyData,
            short: false
        })
    } as IGTMEcommerceItem;

    const ecommerce: IGTMEcommerce = {
        currency: getCurrencyISOCode(offerData.currency),
        value: 1,
        items: [item]
    };

    hitGoogleTagManager({
        event: "add_to_cart",
        event_category: getGtmEcommerceOfferEventCategoryByLeadType(leadType),
        ecommerce
    });
};
